var _defs, _rect, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlaceholder01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 586 390",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #7896d2;\n      }\n\n      .st0, .st1 {\n        fill-rule: evenodd;\n      }\n\n      .st2 {\n        fill: none;\n        stroke: #2a38a6;\n        stroke-miterlimit: 10;\n        stroke-width: 10px;\n      }\n\n      .st2, .st3 {\n        opacity: .4;\n      }\n\n      .st1 {\n        fill: #2836ab;\n      }\n\n      .st4 {\n        fill: #f5f5f5;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: -16,
    y: -11,
    width: 619,
    height: 412.67
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.12,257.96v-126.55c0-17.57-14.23-31.79-31.79-31.79s-31.79,14.23-31.79,31.79v127.17c0,5.2,1.29,10.5,3.96,15.37,8.5,15.37,27.83,20.96,43.2,12.46,10.69-5.92,16.61-17.04,16.42-28.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.47,258.15v-126.74c0-17.57-14.23-31.79-31.79-31.79s-31.79,14.23-31.79,31.79v127.13c0,5.2,1.24,10.5,3.96,15.42,8.5,15.37,27.83,20.96,43.2,12.46,10.6-5.87,16.57-16.9,16.42-28.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.68,147.64c2.82-4.77,4.44-10.31,4.44-16.23,0-17.57-14.23-31.79-31.79-31.79-11.6,0-21.77,6.25-27.35,15.56l-73.42,127.41c-5.44,9.31-5.97,21.2-.38,31.36,8.5,15.37,27.83,20.96,43.2,12.46,5.35-2.96,9.5-7.21,12.32-12.17l72.99-126.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.35,147.64c2.82-4.77,4.44-10.31,4.44-16.23,0-17.57-14.23-31.79-31.79-31.79-11.6,0-21.77,6.25-27.35,15.56l-73.42,127.41c-5.44,9.31-5.97,21.2-.38,31.36,8.5,15.37,27.83,20.96,43.2,12.46,5.35-2.96,9.5-7.21,12.32-12.17l72.99-126.6Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 293,
    cy: 195,
    r: 176.39
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlaceholder01);
export default __webpack_public_path__ + "static/media/video_placeholder01.6f4b48379f595b74fab0e09196258e34.svg";
export { ForwardRef as ReactComponent };